import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "rc-formLabel"
};
const _hoisted_2 = {
    key: 0,
    class: "rc-required"
};
import { useVModel } from "@vueuse/core";
import { computed, watch } from "vue";
// Components
import Selector from "./components/SelectorWrapper.vue";
// Scripts
import { vTooltip } from "@/common/directives/tip-directive";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'CompositeSelector',
    props: {
        selectorConfig: {},
        modelValue: {},
        columns: { default: undefined },
        gridStyle: { default: undefined },
        highlightEmpty: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const gridStyle = computed(() => {
            return props.gridStyle
                ? props.gridStyle.map((ratio) => `minmax(0, ${ratio}fr)`).join(" ")
                : `repeat(${columns.value}, minmax(0, 1fr))`;
        });
        const columns = computed(() => props.columns ?? props.selectorConfig.length);
        const selectorValue = useVModel(props, "modelValue");
        const map = computed(() => {
            return props.selectorConfig.reduce((acc, option) => {
                acc[option.id] = selectorValue.value[option.id];
                return acc;
            }, {});
        });
        const getId = (idx) => {
            return props.selectorConfig.slice(0, idx).reduce((str, o) => {
                str += o.id;
                if (selectorValue.value[o.id] != undefined && !Array.isArray(selectorValue.value[o.id])) {
                    str += ":" + selectorValue.value[o.id]?.id;
                }
                return str;
            }, props.selectorConfig[idx].id + ":");
        };
        const stillDependant = computed(() => {
            return props.selectorConfig.map((o) => {
                if (o.dependsOn) {
                    const dependsOn = o.dependsOn;
                    const value = selectorValue.value[dependsOn];
                    if (Array.isArray(value)) {
                        return value.length <= 0;
                    }
                    return value == undefined || (!Array.isArray(value) && value?.id === undefined);
                }
                return false;
            });
        });
        watch(map, (newValue, oldvalue) => {
            const idx = props.selectorConfig.findIndex((o) => newValue[o.id] !== oldvalue[o.id]);
            if (idx >= 0) {
                props.selectorConfig.slice(idx + 1).forEach((o) => {
                    if (o.defaultValue) {
                        if (selectorValue.value[o.id] != undefined) {
                            if ("ids" in selectorValue.value[o.id] &&
                                selectorValue.value[o.id]?.id != o.defaultValue) {
                                selectorValue.value[o.id] = { id: o.defaultValue };
                            }
                        }
                    }
                    else {
                        selectorValue.value[o.id] = undefined;
                    }
                });
            }
        }, { deep: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "rec-value-picker__grid",
                style: _normalizeStyle({ gridTemplateColumns: gridStyle.value })
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectorConfig, (option, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: getId(idx),
                        class: "rec-value-picker__col"
                    }, [
                        (!option.condensed)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
                                _createTextVNode(_toDisplayString(option.label), 1),
                                (option.required)
                                    ? _withDirectives((_openBlock(), _createElementBlock("abbr", _hoisted_2, _cache[0] || (_cache[0] = [
                                        _createTextVNode("*")
                                    ]))), [
                                        [_unref(vTooltip), _ctx.$t('Required Field')]
                                    ])
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        _createVNode(Selector, {
                            modelValue: _unref(selectorValue)[option.id],
                            "onUpdate:modelValue": ($event) => ((_unref(selectorValue)[option.id]) = $event),
                            config: option,
                            disabled: stillDependant.value[idx],
                            "highlight-empty": _ctx.highlightEmpty
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "config", "disabled", "highlight-empty"])
                    ]));
                }), 128))
            ], 4));
        };
    }
});
